import { marketingRouteMeta } from '#marketing/lib/marketing-route-meta.js';
import { MarketingFaqPage } from '#marketing/components/MarketingFaqPage.jsx';

/** @param {{ matches: Array<{ id?: string, pathname?: string, data?: unknown }> }} args */
export function meta({ matches }) {
  return marketingRouteMeta({ matches, page: 'faq', pagePath: '/faq' });
}

export default function Faq() {
  return <MarketingFaqPage />;
}
